const notificationTypes = {
	FETCH: {
		REQUEST: 'NOTIFICATION_FETCH_REQUEST',
		SUCCESS: 'NOTIFICATION_FETCH_SUCCESS',
		FAILURE: 'NOTIFICATION_FETCH_FAILURE',
		CLEAR: 'NOTIFICATION_FETCH_CLEAR',
	},

	UPDATE: {
		REQUEST: 'NOTIFICATION_UPDATE_REQUEST',
		SUCCESS: 'NOTIFICATION_UPDATE_SUCCESS',
		FAILURE: 'NOTIFICATION_UPDATE_FAILURE',
		CLEAR: 'NOTIFICATION_UPDATE_CLEAR',
	},
};

export default notificationTypes;
